export default __webpack_public_path__ + "static/media/spatter2.10a1fd74.png";